import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty, sortBy, uniqBy } from 'lodash';
import { useHistory, useLocation, Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Page_Size, RightsAccess } from '../../Components/helper';
import BtnAdd from '../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../Components/Utility/FilterAction/BtnDelete';
import SearchBar from '../../Components/Utility/FilterAction/SearchBar';
import Loader from '../../Components/Utility/Loader/Loader';
import * as action from './store/OprationalCP.action';
import OprationalCPCard from '../../Components/Card/OprationalCPCard/OprationalCPCard';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import * as systemMasterAction from '../SystemMasters/Store/SystemMasters.action';

function OprationalCPIndex() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(location?.search);
  const locaStates = location?.state;
  const fromArch = searchParams.get('fromArchive');
  const callArchiveApi = locaStates?.fromArchive || Boolean(fromArch);
  const { t } = useTranslation('common');
  const {
    UserDetails: { isSupplierLoggedIn },
    oprationalCPDetails: { unarchivedCardsList, totalCards },
    Users: { logInRights, sectionAccess },
  } = useSelector((reducer) => reducer);
  const { CheckActionPermission } = useComponent();

  const OperationalAddEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'addEdit');
  const OperationalDeleteAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'delete');
  const { operationalCriticalPathRight, productCriticalPathRight } = RightsAccess();
  const [state, setState] = useState({
    selectedIdArray: [],
    cards: [],
    searchText: '',
    hasMore: false,
    pageIndex: 1,
    pageSize: Page_Size,
    archiveSection: false,
    showArchivePopup: false,
    archivedId: '',
    archiveComment: '',
    showDeletePopup: false,
    deleteId: '',
    loading: false,
    showMobileSearch: true,
    searchLoaded: false,
    subBrandAccess: false,
  });
  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      const subBrandAccessRes = await dispatch(systemMasterAction.getSubBrandAccess());
      setState((prev) => ({
        ...prev,
        subBrandAccess: subBrandAccessRes?.data || false,
      }));
    };
    fetchSubBrandAccess();
  }, [dispatch]);

  useEffect(() => {
    const initialFunctions = async () => {
      setState((prev) => ({
        ...prev,
        loading: true,
      }));
      await dispatch(action.clearReducer());
      const res = await dispatch(
        action.fetchUnArchiveCardData({
          pageIndex: 1,
          pageSize: state.pageSize,
          archived: !!callArchiveApi,
        }),
      );
      res &&
        setState((prev) => ({
          ...prev,
          loading: false,
          archiveSection: !!callArchiveApi,
        }));
    };
    initialFunctions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(unarchivedCardsList)) {
      setState((prev) => ({
        ...prev,
        cards: [...unarchivedCardsList],
      }));
    }
  }, [unarchivedCardsList]);

  useEffect(() => {
    const count = totalCards;
    if (!state.loading) {
      setState((prev) => ({
        ...prev,
        hasMore: count !== unarchivedCardsList.length,
      }));
    }
  }, [totalCards, unarchivedCardsList, state.loading]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((debouncestate) => ({
          ...debouncestate,
          loading: true,
          pageIndex: 1,
          cards: [],
          hasMore: false,
          selectedIdArray: [],
        }));
        const optns = {
          pageIndex: 1,
          pageSize: state.pageSize,
          searchText: state.searchText,
          archived: state.archiveSection,
        };
        await dispatch(action.clearReducer());
        const res = await dispatch(action.fetchUnArchiveCardData(optns));
        res &&
          setState((debstate) => ({
            ...debstate,
            loading: false,
            searchLoaded: false,
          }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.searchText, dispatch, state.archiveSection]);

  const ShowArchivecps = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    await dispatch(action.clearReducer());
    const res = await dispatch(
      action.fetchUnArchiveCardData({
        pageIndex: 1,
        pageSize: 20,
        archived: true,
      }),
    );
    res &&
      setState((prev) => ({
        ...prev,
        archiveSection: true,
        loading: false,
        searchText: '',
        selectedIdArray: [],
      }));
  };

  const ShowunArchivecps = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    await dispatch(action.clearReducer());
    const res = await dispatch(
      action.fetchUnArchiveCardData({
        pageIndex: 1,
        pageSize: state.pageSize,
        archived: false,
      }),
    );
    res &&
      setState((prev) => ({
        ...prev,
        archiveSection: false,
        loading: false,
        searchText: '',
        selectedIdArray: [],
      }));
  };

  const selectedCard = (e, id) => {
    if (e?.target?.checked) {
      setState((prev) => ({
        ...prev,
        selectedIdArray: [...state.selectedIdArray, id],
      }));
    } else {
      const array = [...state.selectedIdArray];
      const updatedArray = array.filter((arrId) => arrId !== id);
      setState((prev) => ({
        ...prev,
        selectedIdArray: [...updatedArray],
      }));
    }
  };

  const handleCardEdit = (id) => {
    history.push({
      pathname: `/operational-cp/create/${id}`,
      state: { fromArchive: state.archiveSection },
    });
  };
  const handleDuplicate = (item) => {
    history.push({
      pathname: `/operational-cp/create/${item._id}`,
      state: { ...item },
    });
  };

  const activeInActiveCard = async (item, index) => {
    let params = {};
    params = {
      operationalIds: [item?._id],
      keyName: 'isActiveInactive',
      isActive: !item?.isActive,
    };
    const res = await dispatch(action.deleteCard({ ...params }, t));
    if (res) {
      const oldCards = state.cards;
      oldCards[index].isActive = !item?.isActive;
      setState((oldState) => ({ ...oldState, cards: oldCards }));
    }
  };
  const handlePinCard = async (item) => {
    const params = {
      ...item,
      pinned: !item?.pinned,
    };
    const { cards } = state;
    const foundIndex = cards.findIndex((card) => card?._id === item?._id);
    cards[foundIndex].pinned = !item?.pinned;
    let newCards = [];
    const sortedCards = sortBy(cards, ['pinned', 'createdAt']).reverse();
    const pinnedSortedCards = sortedCards.filter((ocpEle) => ocpEle.pinned);
    const unpinnedSortedCards = sortedCards.filter((ocpEle) => !ocpEle.pinned && !ocpEle.lastOpned);
    const lastOpnedCards = sortedCards.filter((ocpEle) => !ocpEle.pinned && ocpEle.lastOpned);
    newCards = [...pinnedSortedCards, ...lastOpnedCards, ...unpinnedSortedCards];
    const res = await dispatch(action.addCard(params, t));
    res &&
      setState((prev) => ({
        ...prev,
        cards: newCards,
      }));
  };

  const deleteCard = (id) => {
    setState((prev) => ({
      ...prev,
      showDeletePopup: true,
      deleteId: id,
    }));
  };

  const conformDelete = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    let params = {};
    if (state.deleteId === null) {
      params = {
        operationalIds: [...state.selectedIdArray],
        keyName: 'isDeleted',
      };
    } else {
      params = { operationalIds: [state.deleteId], keyName: 'isDeleted' };
    }
    const res = await dispatch(action.deleteCard({ ...params }, t));
    if (res) {
      const oldCards = state.cards;
      let newCards = [];
      if (state.deleteId) {
        newCards = oldCards.filter((oldEle) => oldEle?._id !== state.deleteId);
      } else {
        newCards = oldCards.filter((oldEle) => !state.selectedIdArray.includes(oldEle?._id));
      }
      setState((oldState) => ({ ...oldState, cards: newCards }));
      toggleDeleteModal();
    }
  };

  const toggleDeleteModal = () => {
    setState((prev) => ({
      ...prev,
      loading: false,
      showDeletePopup: false,
      deleteId: '',
      selectedIdArray: [],
    }));
  };

  const handleCardExpand = (item) => {
    history.push({
      pathname: `/operational-cp/details/${item?._id}`,
      state: { fromArchive: item.isArchived },
    });
  };

  const handleArchiveCard = (id) => {
    setState((prev) => ({
      ...prev,
      showArchivePopup: true,
      archivedId: id,
    }));
  };

  const conformArchive = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    let archiveCardDetails = {};
    if (state.archivedId === null) {
      archiveCardDetails = {
        operationalIds: [...state.selectedIdArray],
        keyName: 'isArchived',
        isArchived: !state.archiveSection,
        archiveComment: state.archiveSection ? '' : state?.archiveComment,
      };
    } else {
      archiveCardDetails = {
        operationalIds: [state.archivedId],
        keyName: 'isArchived',
        isArchived: !state.archiveSection,
        archiveComment: state.archiveSection ? '' : state?.archiveComment,
      };
    }
    const res = await dispatch(action.deleteCard({ ...archiveCardDetails }, t));
    if (res) {
      const oldCards = state.cards;
      let newCards = [];
      if (state.archivedId) {
        newCards = oldCards.filter((oldEle) => oldEle?._id !== state.archivedId);
      } else {
        newCards = oldCards.filter((oldEle) => !state.selectedIdArray.includes(oldEle?._id));
      }
      setState((oldState) => ({
        ...oldState,
        cards: JSON.parse(JSON.stringify(newCards)),
      }));
      toggleArchive();
    }
  };

  const toggleArchive = () => {
    setState((prev) => ({
      ...prev,
      loading: false,
      showArchivePopup: false,
      archivedId: '',
      archiveComment: '',
      selectedIdArray: [],
    }));
  };

  const archiveCommentChanges = (e) => {
    setState((prev) => ({
      ...prev,
      archiveComment: e?.target?.value,
    }));
  };

  const handleNextPageInScroll = async () => {
    let { pageIndex } = state;
    pageIndex += 1;
    setState((nextPagestate) => ({
      ...nextPagestate,
      pageIndex,
      loading: true,
    }));
    const params = {
      pageIndex,
      pageSize: state?.pageSize,
      searchText: state?.searchText,
      archived: state?.archiveSection,
    };
    const result = await dispatch(action.fetchUnArchiveCardData(params));
    if (result) {
      setState((nextPagestate) => ({
        ...nextPagestate,
        loading: false,
      }));
    }
  };

  const handleSearch = (e) => {
    const targetValue = e.target.value;
    setState((searchState) => ({
      ...searchState,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  const handleMobileSearch = (clear) => {
    if (clear) {
      setState((mobstate) => ({
        ...mobstate,
        searchText: '',
        searchLoaded: true,
        showMobileSearch: !state.showMobileSearch,
      }));
    }
  };

  const deleteMessageInarchive = () => {
    return state.deleteId === null
      ? t('OPERATIONAL_CP.CRITICAL_INDEX.DELETE_MESSAGE_ARCHIVE_CONFIRMATION')
      : t('OPERATIONAL_CP.CRITICAL_INDEX.DELETE_MESSAGE_UNARCHIVE_CONFIRMATION');
  };

  const deleteMessageInUnarchive = () => {
    return state.deleteId === null ? t('OPERATIONAL_CP.CRITICAL_INDEX.DELETE_MESSAGE') : t('OPERATIONAL_CP.CRITICAL_INDEX.ARE_U_SURE_WANT_CRITICAL_MESSAGE');
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('OPERATIONAL_CP.CRITICAL_INDEX.TITLE')}</h4>
        </div>
        <div className="search-filter">
          <SearchBar
            onSearch={handleSearch}
            value={state.searchText}
            showMobileSearch={state.showMobileSearch}
            placeholder={
              state.archiveSection ? t('OPERATIONAL_CP.CRITICAL_INDEX.SEARCH_ARCHIVED_PLACEHOLDER') : t('OPERATIONAL_CP.CRITICAL_INDEX.SEARCH_PLACEHOLDER')
            }
            handleMobileSearch={handleMobileSearch}
          />

          {OperationalAddEditAccess && (
            <>
              {!state.archiveSection && (
                <Link className="cursor-pointer text-dark text-decoration-none" to="/operational-cp/create">
                  <BtnAdd forDisable={state.archiveSection || state.loading} addEditAccess={OperationalAddEditAccess} />
                </Link>
              )}{' '}
              <button
                type="button"
                className="filter-btn"
                title={t('OPERATIONAL_CP.CRITICAL_INDEX.ARCHIVE_BUTTON_TITLE')}
                onClick={() => handleArchiveCard(null)}
                disabled={isEmpty(state.selectedIdArray) || state.loading}
              >
                <span className="icon-server" />
              </button>
            </>
          )}
          {OperationalDeleteAccess && state.archiveSection && (
            <BtnDelete multiDelete={() => deleteCard(null)} isDisabled={isEmpty(state.selectedIdArray) || state.loading} />
          )}
        </div>
      </div>
      {state.loading ? (
        <Loader />
      ) : (
        <>
          {!isSupplierLoggedIn && (
            <Container fluid className="d-flex flex-wrap justify-content-end my-2">
              {sectionAccess?.criticalPath?.operationalAccess && operationalCriticalPathRight && (
                <Link
                  className={`cursor-pointer text-dark text-decoration-none btn my-1 my-md-0 btn-page-filter ${!state.archiveSection && 'btn-active'}`}
                  to="/operational-cp"
                  onClick={ShowunArchivecps}
                >
                  {t('OPERATIONAL_CP.CRITICAL_INDEX.OPEN_CP')}
                </Link>
              )}
              {sectionAccess?.criticalPath?.productAccess && productCriticalPathRight && (
                <Link className="cursor-pointer text-dark text-decoration-none btn my-1 my-md-0 btn-page-filter" to="/product-cp">
                  {t('OPERATIONAL_CP.CRITICAL_INDEX.OPEN_PRODUCT_CP')}
                </Link>
              )}
              {sectionAccess?.criticalPath?.operationalAccess && operationalCriticalPathRight && (
                <Link
                  className={`cursor-pointer text-dark text-decoration-none btn my-1 my-md-0 btn-page-filter ${state.archiveSection && 'btn-active'}`}
                  to="/operational-cp?fromArchive=true"
                  onClick={ShowArchivecps}
                >
                  {t('OPERATIONAL_CP.CRITICAL_INDEX.ARCHIVED_CP')}
                </Link>
              )}
              {sectionAccess?.criticalPath?.productAccess && productCriticalPathRight && (
                <Link className="cursor-pointer text-dark text-decoration-none btn my-1 my-md-0 btn-page-filter" to="/product-cp?fromArchive=true">
                  {t('OPERATIONAL_CP.CRITICAL_INDEX.ARCHIVE_PRODUCT_CPS')}
                </Link>
              )}
            </Container>
          )}
          {isEmpty(state.cards) && (
            <Container fluid className="py-4">
              <Row>
                <Col md="12">
                  <p className="alert alert-info override-alert-info justify-content-center align-item-center d-flex">
                    {t('OPERATIONAL_CP.CRITICAL_INDEX.NO_CP_FOUND')}
                  </p>
                </Col>
              </Row>
            </Container>
          )}
        </>
      )}
      {!isEmpty(state?.cards) && (
        <InfiniteScroll dataLength={unarchivedCardsList?.length} loader={state.loading && <Loader />} hasMore={state.hasMore} next={handleNextPageInScroll}>
          <div className="container-fluid">
            <div className="row">
              {uniqBy(state?.cards, '_id')?.map((unArchItems, unArchIndex) => {
                return (
                  <div key={unArchIndex} className="col-lg-4 col-xlarge-3 OCP-Card">
                    <OprationalCPCard
                      item={unArchItems}
                      index={unArchIndex}
                      selectedIds={state.selectedIdArray}
                      isSupplierLoggedIn={isSupplierLoggedIn}
                      isArchived={state.archiveSection}
                      onCheck={selectedCard}
                      handlePin={handlePinCard}
                      handleEdit={handleCardEdit}
                      deleteCard={deleteCard}
                      handleExpand={handleCardExpand}
                      archiveCard={handleArchiveCard}
                      activeInActiveCard={activeInActiveCard}
                      handleDuplicate={handleDuplicate}
                      OperationalAddEditAccess={OperationalAddEditAccess}
                      OperationalDeleteAccess={OperationalDeleteAccess}
                      subBrandAccess={state.subBrandAccess}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </InfiniteScroll>
      )}
      {state.showArchivePopup && (
        <ConfirmationPopup
          onOpen={state.showArchivePopup}
          onConfirm={conformArchive}
          title={`${state.archiveSection ? t('OPERATIONAL_CP.CRITICAL_INDEX.UNARCHIVE') : t('OPERATIONAL_CP.CRITICAL_INDEX.ARCHIVE')} ${t(
            'OPERATIONAL_CP.CRITICAL_INDEX.OPERATIONAL_CP',
          )}`}
          message={`${t('OPERATIONAL_CP.CRITICAL_INDEX.ARCHIVE_CONFIRMATION_MESSAGE')} ${
            state.archiveSection ? t('OPERATIONAL_CP.CRITICAL_INDEX.UNARCHIVES') : t('OPERATIONAL_CP.CRITICAL_INDEX.ARCHIVES')
          } ${t('OPERATIONAL_CP.CRITICAL_INDEX.SELECTED_OPERATIONAL_PATH')}`}
          secondMessage={state.archiveSection && t('OPERATIONAL_CP.CRITICAL_INDEX.CLEAR_COMMENTS_MESSAGE')}
          toggle={toggleArchive}
          isCommentOn={!state.archiveSection}
          commentText={archiveCommentChanges}
          comment={state.archiveComment}
          loading={state.loading}
          showCommentHeader
        />
      )}

      {state.showDeletePopup && (
        <ConfirmationPopup
          onOpen={state.showDeletePopup}
          onConfirm={conformDelete}
          title={t('OPERATIONAL_CP.CRITICAL_INDEX.DELETE_TITLE')}
          message={state.archiveSection ? deleteMessageInarchive() : deleteMessageInUnarchive()}
          toggle={toggleDeleteModal}
          loading={state.loading}
        />
      )}
    </>
  );
}

export default OprationalCPIndex;
